import { TmrBaseResource } from 'stylewhere/api'

export class Zones extends TmrBaseResource {
  static endpoint = 'profile/api/v1/zones'
}
